export default __webpack_public_path__ + "static/logo-eb8c99b62c6f3780e76ee0d77e4d3ade.svg";